export default __webpack_public_path__ + "static/blob4-dfa690471fc526d0dc64b5a74a6e3505.svg";